import {
  foldService, codeFolding, foldCode, unfoldCode, foldAll, unfoldAll, foldedRanges
} from "@codemirror/language"

const HEADING = /^(#{1,6})\s/
const LIST_ITEM = /^(\s*)(?:[-*+]|\d+[.)])\s/

function lineIndent(text) {
  const match = text.match(/^\s*/)
  return match[0].replace(/\t/g, "  ").length
}

function headingFold(state, line) {
  const level = line.text.match(HEADING)[1].length
  let last = line.number
  for (let n = line.number + 1; n <= state.doc.lines; n++) {
    const next = state.doc.line(n)
    const heading = next.text.match(HEADING)
    if (heading && heading[1].length <= level) break
    if (next.text.trim()) last = n
  }
  return last > line.number ? { from: line.to, to: state.doc.line(last).to } : null
}

function listFold(state, line, indent) {
  let last = line.number
  for (let n = line.number + 1; n <= state.doc.lines; n++) {
    const next = state.doc.line(n)
    if (!next.text.trim()) continue
    if (lineIndent(next.text) <= indent) break
    last = n
  }
  return last > line.number ? { from: line.to, to: state.doc.line(last).to } : null
}

const outlineFoldService = foldService.of((state, from) => {
  const line = state.doc.lineAt(from)
  if (HEADING.test(line.text)) return headingFold(state, line)
  const item = line.text.match(LIST_ITEM)
  if (item) return listFold(state, line, item[1].replace(/\t/g, "  ").length)
  return null
})

const foldedWordCount = codeFolding({
  preparePlaceholder(state, range) {
    return state.sliceDoc(range.from, range.to).match(/[\p{L}\p{N}_'-]+/gu)?.length || 0
  },
  placeholderDOM(_view, onclick, words) {
    const pill = document.createElement("span")
    pill.className = "cm-foldPlaceholder"
    pill.textContent = words === 1 ? "… 1 word" : `… ${words.toLocaleString()} words`
    pill.title = "Unfold (⌘.)"
    pill.onclick = onclick
    return pill
  }
})

export function toggleFoldAtCursor(view) {
  return unfoldCode(view) || foldCode(view)
}

export function toggleAllFolds(view) {
  let anyFolded = false
  foldedRanges(view.state).between(0, view.state.doc.length, () => {
    anyFolded = true
    return false
  })
  return anyFolded ? unfoldAll(view) : foldAll(view)
}

export const outlineFolding = [outlineFoldService, foldedWordCount]
